"use client";

import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

export function useMockDate(): Date | undefined {
    const searchParams = useSearchParams();
    const mockStatus = searchParams.get("mockStatus");

    return useMemo(() => {
        if (!mockStatus || mockStatus === "current") {
            return undefined;
        }

        // Use dates that work for both CADA (Nov 2025 - May 2026) and NADA (Sept 2025 - March 2026)
        const statusToDate: Record<string, string> = {
            "not-yet-open": "2025-08-01", // Before both open
            open: "2025-12-01", // During both enrollment periods
            extension: "2026-03-10", // Warning period for both
            "submission-only": "2026-04-01", // After both enrollment closes
            closed: "2026-06-01", // After both submission deadlines
        };

        const dateStr = statusToDate[mockStatus];
        return dateStr ? new Date(dateStr) : undefined;
    }, [mockStatus]);
}
